/**
 * oms micro front end sdk
 */

// import Zntry from '@zn-collect/monitor';
import { microAppList, microAppMark } from '../../config/micro.config';
import mainBus from './eventBus';

const action = '';

// 获取入口
const getEntry = (item) => {
  // 从本地缓存读取配置信息
  let uiInfo = null;
  try {
    const uiInfoStr = localStorage.getItem("uiInfo");
    if (uiInfoStr) {
      uiInfo = JSON.parse(uiInfoStr);
    }
  } catch (e) {
    console.error("解析 uiInfo 失败", e);
  }
  const startStr = process.env.NODE_ENV === 'development' ? `//localhost:${item.port}` : microAppMark;
  
  // 根据 getAllUiInfo 返回的数据中，对应子应用的开关和 CDN 地址进行判断
  if (uiInfo && uiInfo.assetDomain) {
    return `https://${uiInfo.assetDomain}${microAppMark}${item.activeRule}/index.html`;
  }
  return `${startStr}${item.activeRule}`;
};

const getMicroAppList = () => microAppList.map((app) => ({
  ...app,
  entry: getEntry(app),
  container: `#${app.name}`,
  props: {
    _app: app,
    _setGlobalData: mainBus,
    // _zntry: Zntry,
    // router vuex
  },
}));

export {
  getMicroAppList,
  action,
};
